(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(29458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12569);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44087);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80338);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18838);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_4__);








var getTextSection = function(key, content, isFirst) {
    return content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$0, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
            "-mt-25 md:-mt-32 lg:-mt-40 xl:-mt-60": isFirst
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            className: "flex flex-col items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full max-w-200",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .HtmlToElement */ .Eu, {
                    className: "prose text-stealth-bomber",
                    children: content
                })
            })
        })
    }, key);
};
/**
 * Insert a promo banner by splitting the blog content (promo banner indicated in content as a <blockquote>)
 */ var insertBanner = function(content, banner) {
    var openString = "<blockquote>";
    var closeString = "</blockquote>";
    if (!banner || !(content === null || content === void 0 ? void 0 : content.includes(openString))) {
        return getTextSection("first", content, true);
    }
    var textBlocks = content.split(openString);
    var first = getTextSection("first", textBlocks.shift() || null, true);
    var promoBanner = banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_3__/* .PromoBanner */ .$i, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, banner), {
        className: "md:-my-4 lg:-my-6 xl:-my-12"
    }));
    var rest = textBlocks.map(function(string, i) {
        var block = getTextSection("block".concat(i), string.split(closeString)[1]);
        return [
            promoBanner,
            block
        ];
    }).flat();
    return [
        first,
        rest
    ];
};
var BlogPostPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var data = (0,react_datocms__WEBPACK_IMPORTED_MODULE_7__/* .useQuerySubscription */ .L)(subscription).data;
    if (!data) return null;
    var morePosts = data.morePosts, _page = data.page, seo = _page.seo, title = _page.title, date = _page.date, content = _page.content, publishBlogPostHtml = _page.publishBlogPostHtml, banner = _page.banner, isCoverImage = _page.isCoverImage, image = _page.image, author = _page.author;
    var mainContent = insertBanner(publishBlogPostHtml || content, banner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .SEO */ .HJ, {
                title: "".concat(title, " | Narrative"),
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_8__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$0, {
                isFirstSection: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "mb-8 text-h2 font-semibold text-center leading-tight lg:text-h1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_4__.HorizontalRule, {
                            bottomMargin: true
                        }),
                        image && isCoverImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_9__/* .Image */ .E, {
                                data: image.responsiveImage
                            })
                        }) : null,
                        author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full max-w-200 my-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .BlogAuthor */ .p8, {
                                name: author.name,
                                date: date,
                                image: author.avatar
                            })
                        })
                    ]
                })
            }),
            mainContent,
            morePosts.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .BlogThreeUp */ .Wd, {
                title: "You may also like",
                items: morePosts
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);